import type { Playlist } from "@/types/types";
import { MediaCard } from "./MediaCard";
import { useContextMenu } from "@/hooks/useContextMenu";
import { musicService } from "@/services/musicService";
import { sfx } from "@/lib/sfx";

export function PlaylistCard({ playlist, onDeleted }: {
  playlist: Playlist;
  /** Called after a successful delete so the parent list can drop it
   * without a full refetch. */
  onDeleted?: (id: string) => void;
}) {
  const menu = useContextMenu();

  const doDelete = async () => {
    sfx.tap();
    if (!window.confirm(`Supprimer "${playlist.name}" ? C'est définitif.`)) return;
    try {
      await musicService.deletePlaylist(playlist.id);
      sfx.chirp();
      onDeleted?.(playlist.id);
    } catch {
      window.alert("Suppression impossible.");
    }
  };

  const menuItems = [
    { label: "Supprimer la playlist", onSelect: () => void doDelete() },
  ];

  return (
    <MediaCard
      to={`/playlist/${playlist.id}`}
      coverId={playlist.cover_id}
      title={playlist.name}
      subtitle={playlist.description ?? "Playlist"}
      onContextMenu={(e) => {
        e.preventDefault();
        menu.show({ x: e.clientX, y: e.clientY, items: menuItems });
      }}
    />
  );
}
